import { createAction, createReducer } from "@reduxjs/toolkit";
import { TurboRoom } from "./records";

export type TurboRoomsState = {
  [roomId: string]: TurboRoom;
};

const initialState: TurboRoomsState = {};

// Actions
export const actions = {
  set: createAction<{ roomId: string; turboRoom: TurboRoom }>(
    "entities/turboRooms/set"
  ),
  update: createAction<{ roomId: string; turboRoom: Partial<TurboRoom> }>(
    "entities/turboRooms/update"
  ),
  remove: createAction<string>("entities/turboRooms/remove"),
  clear: createAction("entities/turboRooms/clear"),
};

// Reducer
export const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.set, (state, action) => {
      const { roomId, turboRoom } = action.payload;
      state[roomId] = turboRoom;
    })
    .addCase(actions.update, (state, action) => {
      const { roomId, turboRoom } = action.payload;
      if (state[roomId]) {
        state[roomId] = { ...state[roomId], ...turboRoom };
      }
    })
    .addCase(actions.remove, (state, action) => {
      delete state[action.payload];
    })
    .addCase(actions.clear, () => {
      return initialState;
    });
});

export default reducer;
